import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import WidgetFrame from "./WidgetFrame";
import ProtectedRoute from "components/ProtectedRoute";
import ChatbotWidget from "views/auth/chatbot/ChatbotWidget";

const App = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/*" element={<AuthLayout />} />
      <Route path="widget/:siteId" element={<WidgetFrame />} />
      <Route path="/" element={<Navigate to="/sign-in" replace />} />
      <Route path="/chatbot" element={<ChatbotWidget />} />
      
      {/* Protected routes - Only accessible if authenticated */}
      <Route element={<ProtectedRoute />}>
        <Route path="admin/*" element={<AdminLayout />} />
        <Route path="rtl/*" element={<RtlLayout />} />
      </Route>
    </Routes>
  );
};

export default App;
